import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import {
  ProjectData,
  ProjectsLocationsData,
} from "../../../models/ProjectData";
import DataSvc from "../../../services/dataSvc";
import ScoreItem from "../../ScoreItem";

import "./styles.scss";

export interface IProjectFacilitiesListProps {
  project: ProjectData;
  onOpenProjectLocationDetailsModal: (
    projectLocation: ProjectsLocationsData
  ) => void;
}

export const ProjectFacilitiesList: React.FunctionComponent<
  IProjectFacilitiesListProps
> = (props) => {
  const { project, onOpenProjectLocationDetailsModal } = props;
  const { t: _t } = useTranslation();

  const t = (key: string, params?: { [key: string]: string | number }) =>
    _t(`projectManagementPage.projectFacilitiesList.${key}`, params);

  const { data: projectsLocations } = useQuery<ProjectsLocationsData[]>({
    queryKey: ["projectsLocations", project?.id],
    queryFn: () =>
      DataSvc.getProjectsLocations(
        project.organization_id,
        project.id.toString(),
        {},
      ),
    enabled: !!project,
  });

  const locationCount = projectsLocations?.length || 0;
  const targetFacilityCount = project?.target_facility_count || 0;
  const locationCountText = targetFacilityCount
    ? `${locationCount} / ${targetFacilityCount}`
    : locationCount;

  return (
    <div className="white-border-panel project-facilities-list">
      <div className="project-facilities-list-header">
        <h2 className="project-facilities-list-title">
          {t("facilities_list")}
        </h2>
        <span className="registered-facility-count">
          {t("registered_facility_count", { locationCount: locationCountText })}
        </span>
      </div>
      <table className="project-facilities-list-content">
        <thead>
          <tr>
            <th className="facility-name">{t("table.header.facility_name")}</th>
            <th className="registered-at">{t("table.header.registered_at")}</th>
            <th className="health-index">{t("table.header.health_index")}</th>
            <th className="actions"></th>
          </tr>
        </thead>
        <tbody>
          {projectsLocations &&
            projectsLocations.map((item) => (
              <tr key={item.id}>
                <td className="facility-name">{item.location.name}</td>
                <td className="registered-at">
                  {dayjs(item.location.created_at).format("YYYY/MM/DD")}
                </td>
                <td className="health-index">
                  <ScoreItem
                    score={item.location.location_stats?.score || "n"}
                  />
                </td>
                <td className="actions">
                  <button
                    className="btn btn-border"
                    onClick={() => onOpenProjectLocationDetailsModal(item)}
                  >
                    {t("table.row.details")}
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};
